import { Grid } from '@mui/material';
import ExpandIcon from '@square-icons/react/24/UI/chevron-down';
import {
  ShopAccordion,
  ShopAccordionSummary,
  ShopAccordionDetails,
} from 'components/common/shop_accordion';
import UpsellCard from 'components/common/upsell_card';
import { shopImageSrcSet } from 'utilities/images';
import { trackCdp } from 'utilities/tracking';
import { useProductContext } from 'typescript/pages/product/contexts/product_context';

export const TrackingEventTypes = {
  AddToCart: 'AddToCart',
  ModalViewButtonClicked: 'ModalViewButtonClicked',
  AccordionExpanded: 'AccordionExpanded',
};

const UpsellAccordion = (props) => {
  const {
    upsells,
    title,
    image,
    setAccessoryModal,
    cardQuantities,
    setCardQuantities,
  } = props;

  const { cart } = useProductContext();

  const trackEvent = ({ eventName, params }) => {
    const defaultParams = {
      feature: 'shop',
      cartNumber: cart?.number,
    };

    trackCdp({
      name: `Upsell:${eventName}`,
      params: { ...defaultParams, ...params },
    });
  };

  const updateQuantity = (slug, updatedQuantity) => {
    setCardQuantities({ ...cardQuantities, [slug]: updatedQuantity });
  };

  const cards = upsells.map((upsell) => (
    <Grid item key={upsell.name}>
      <UpsellCard
        upsell={upsell}
        quantity={cardQuantities[upsell.slug]}
        updateQuantity={updateQuantity}
        setAccessoryModal={setAccessoryModal}
        trackEvent={trackEvent}
        trackingEventTypes={TrackingEventTypes}
      />
    </Grid>
  ));

  const onAccordionChange = (event, expanded) => {
    if (expanded) {
      trackEvent({
        eventName: TrackingEventTypes.AccordionExpanded,
        params: {
          categoryName: title,
        },
      });
    }
  };

  return (
    <ShopAccordion onChange={onAccordionChange}>
      <ShopAccordionSummary expandIcon={<ExpandIcon />}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <img
              srcSet={shopImageSrcSet({
                baseUrl: image,
                type: 'accordionProductTile',
                fm: 'png',
              })}
              width="50px"
              height="50px"
            />
          </Grid>
          <Grid item>
            <p>{title}</p>
          </Grid>
        </Grid>
      </ShopAccordionSummary>
      <ShopAccordionDetails>
        <Grid container direction="column" spacing={2}>
          {cards}
        </Grid>
      </ShopAccordionDetails>
    </ShopAccordion>
  );
};

export default UpsellAccordion;
